module.exports = __webpack_public_path__ + "img/logo.5e8a25eb.svg";